module.exports = __webpack_public_path__ + "img/container.d1cf1d22.svg";